export { default } from './TextImageSecond';



// WEBPACK FOOTER //
// ./src/components/templates/TextImageSecond/index.js